import { DecimalPipe } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import {
  NbCardModule,
  NbIconModule,
  NbProgressBarModule,
  NbUserModule,
} from "@nebular/theme";
import { ProgressService } from "app/@core/services/progress.service";
import { Course, Module } from "app/@core/types";
import { LineTruncationLibModule } from "../../modules/line-truncation/line-truncation.module";
import { LessonListComponent } from "../lesson-list/lesson-list.component";

@Component({
  standalone: true,
  selector: "ngx-masterclass",
  templateUrl: "./masterclass.component.html",
  imports: [
    NbCardModule,
    NbIconModule,
    NbProgressBarModule,
    LineTruncationLibModule,
    NbUserModule,
    LessonListComponent,
    DecimalPipe,
    RouterLink,
  ],
})
export class MasterclassComponent {
  private progressService = inject(ProgressService);

  course = input.required<Course>();
  masterclass = input.required<Module>();
  type = input<string>("my");
  size = input<any>("medium");
  link = input<boolean>(false);

  readonly progress = computed(() => {
    const masterclass = this.masterclass();
    const progress = this.progressService.progress(); // Assume this is a signal
    if (this.type() != "my") return 0;

    if (!masterclass?.lessons?.length || !progress?.masterclasses) {
      return 0;
    }

    const mLessons = masterclass.lessons;
    const pMasterclasses = progress.masterclasses;

    const completedCount = mLessons.filter(
      (lesson) => pMasterclasses[lesson.id]?.status === "Completed"
    ).length;

    // Return the percentage (rounded to 2 decimal places if needed)
    const result = (completedCount * 100) / mLessons.length;
    return Math.round(result);
  });
}
